<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-news bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("news.news-target") }}</h5>
            </div>
          </div>
          <div v-if="loading" class="mt-4 mx-auto p-5">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              ></div>
            </div>
          </div>
          <div class="col-sm-12 mt-4" v-if="!loading">
            <div class="row mt-4 mb-2">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t("news.show") }}&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="md"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("news.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('news.searchh')"
                      class="form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(target)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <img
                        :src="url_image + row.item.image_project"
                        class="mr-3 rounded-circle avatar-sm"
                        alt="user-pic"
                      />
                      <div class="media-body">
                        <b> {{ row.item.title }}</b> <br />
                        <p class="text-secondary">
                          {{ $t("news.updated") }} :
                          {{ formatDate(row.item.updated_at) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
                <template #cell(description)="row">
                  <span> {{ row.item.description.substring(0, 100) }}... </span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'news-target-detail',
                      params: { id: row.item.id_target },
                    }"
                    ><b-button class="mr-1 btn-sm mb-1" variant="secondary">
                      {{ $t("news.view-news") }}
                    </b-button>
                  </router-link>
                </template>
              </b-table>

              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col-sm-12 text-right">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 text-center"
            v-if="!tableData[0] && !loading && search"
          >
            <p class="text-secondary p-5">{{ $t("overview.table.all.dnf") }}</p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import NewsService from "@/helpers/news.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      backUrl: "/news",
      url_image:
        process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      target: "",
      loading: false,
      loadingInfo: false,
      loadingsubdomain: false,
      search: false,
      searchKey: "",
      SearchResult: "",
      total_results: "",
      relation: [],
      options: [],
      tableData: [],
      checkedBulk: [],
      searchTarget: "",
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,
      title: this.$t("news.news-target"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("news.news"),
          href: "/news",
        },
        {
          text: this.$t("news.news-target"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: ["target", "description", "category"],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          label: "#",
        },
        {
          key: "target",
          label: this.$t("news.target-profile"),
          sortable: true,
        },
        {
          key: "description",
          thStyle: { width: "30%" },
          label: this.$t("news.description"),
          sortable: true,
        },
        { key: "category", label: this.$t("news.category"), sortable: true },
        {
          key: "total",
          class: "text-center",
          label: this.$t("news.total-news"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("news.actions"),
          class: "text-center",
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },
  },
  methods: {
    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },

    listProfile() {
      this.loading = true;
      TargetService.getTargetByNews()
        .then((response) => {
          // console.log( response.data.data);
          response.data.data.forEach((val, idx) => {
            const data = {
              no: idx + 1,
              id_target: val.id_target,
              title: val.title,
              target: val.title,
              total: val.news_count,
              image_project: val.image_project,
              description: val.description,
              category: val.category.category_name,
              news: val.news,
              updated_at: val.updated_at,
            };
            this.tableData.push(data);
          });

          console.log("tabel Data ==:> ", this.tableData);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    onOptionClick(option) {
      this.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },
  beforeMount() {
    this.listProfile();
  },
  mounted() {
    this.totalRows = this.items.length;
    // this.getNewsInfo();
    this.availableOptions;
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>